module.exports = __webpack_public_path__ + "static/media/ops2.png.4aff4b78.jpg";